import React from 'react';
import { FILTER_CONFIG_NAMES } from './DataConstants';
import { getIsActiveFilterField } from './FilterUtils';
import TagDisplay from '../components/TagDisplay';

export const TAG_FILTER_RENDER_FIELDS = {
	labelAccessor: (tag) => <TagDisplay tag={tag} />,
	renderItem: (tag) => <TagDisplay tag={tag} />,
	renderSelectedText: (tag) => tag.label,
};

export const getPartsFilterConfig = ({ filters, updateFilters, targetCollectionName }) => {
	const vendorFilter = filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS]
		? {
				...filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS],
				handleChange: undefined,
		  }
		: null;

	const tagsFilter = filters[FILTER_CONFIG_NAMES.TAGS]
		? {
				...filters[FILTER_CONFIG_NAMES.TAGS],
				handleChange: undefined,
				...TAG_FILTER_RENDER_FIELDS,
		  }
		: null;

	return [
		getIsActiveFilterField(updateFilters, targetCollectionName, true),
		vendorFilter,
		tagsFilter,
	].filter(Boolean);
};
